(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the header-block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @return  void
	 */
	$(document).ready(function () {
		// Function to handle menu toggle on mobile
		$('#navbar-toggler').on('click', function () {
			const menu = $('#navbar-menu');
			const expanded = $(this).attr('aria-expanded') === 'true';

			// Toggle the aria-expanded attribute
			$(this).attr('aria-expanded', !expanded);

			// Toggle full-screen menu visibility using Tailwind classes
			menu.toggleClass('hidden');
		});

		// Close menu when clicking the close icon (X button)
		$('#navbar-close').on('click', function () {
			$('#navbar-menu').addClass('hidden'); // Hide the menu
			$('#navbar-toggler').attr('aria-expanded', 'false'); // Reset the toggle button state
		});

		// Close menu when clicking anywhere on the full-width background
		$('#navbar-menu').on('click', function (e) {
			// Close menu only if the clicked target is the background, not the menu items or the close icon
			if ($(e.target).is('#navbar-menu')) {
				$('#navbar-menu').addClass('hidden'); // Hide the menu
				$('#navbar-toggler').attr('aria-expanded', 'false'); // Reset the toggle button state
			}
		});
	});
	$(document).ready(function () {
		// Show search input when the search icon is clicked
		$('.search-ico').on('click', function (e) {
			e.preventDefault();
			$(this).addClass('hidden'); // Hide the search icon
			$('#search-form-input').removeClass('md:hidden'); // Show the input field
			$('.submit-ico').removeClass('md:hidden'); // Show the submit button
			$('#search-form-input').focus(); // Optional: Focus on the input field for better user experience
		});

		// Handle the submit action when the submit icon is clicked
		$('.submit-ico').on('click', function (e) {
			e.preventDefault();
			const inputVal = $('#search-form-input').val().trim(); // Get the input value
			if (inputVal !== '') {
				window.location.href = '/?s=' + encodeURIComponent(inputVal); // Redirect to the search results page
			}
		});

		// Handle the Enter key press in the search input
		$('#search-form-input').on('keypress', function (e) {
			if (e.key === 'Enter') {
				// Check if Enter key is pressed
				const inputVal = $(this).val().trim(); // Get the value of the input field
				if (inputVal !== '') {
					window.location.href =
						'/?s=' + encodeURIComponent(inputVal); // Redirect to the search results page
				} else {
					alert('Please fill in the input field.'); // Alert if the input is empty
				}
			}
		});
	});

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-header-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=header-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
